/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { helperFunctions as _h } from "../../utils/helper";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

const getPlateGradeList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/master/list_all_plate_grades?status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getAreaCategoryList = async (grade_id ?: any) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/area_category/list_all_area_category?&sort=id&status=active&order=asc&id=&grade_id=${grade_id}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getActivityTypeList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/master_activities/list?sort=id&status=active&order=asc`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//Frequency Schedule
const getFrequencyList = async (
  page: number,
  size: number,
  sort: string,
  order: string,
  keyWord: any,
  areaGradeId: string,
  activityTypeId: string,
  locationCategoryId: string,
) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/frequency/list?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active,inactive&area_grade_id=${areaGradeId}&activity_type_id=${activityTypeId}&location_category_id=${locationCategoryId}&keyword=${keyWord}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const createScheduleFrequency = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/frequency/save`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const changeFrequencyScheduleStatus = async (
  id: string,
  status: string,
  interface_name: string
) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/frequency/change_status`,
      {
        id: id,
        status: status,
        interface_name: interface_name,
      },
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//Production Schedule
const getProductionScheduleList = async (
  page: number,
  size: number,
  sort: string,
  order: string,
  keyWord: any,
  fromDate?: string,
  toDate?: string,
  productionType?: string,
  areaId?: string,
  isCompleted?: any,
) => {
  try {
    const response = await axiosInstance.get(
      // `${baseUrl}/api/v1/schedule/production/list?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyWord}&production_type=${productionType}&area_id=${areaId}&from_date_time=${fromDate || ""}&to_date_time=${toDate || ""}`,
      `${baseUrl}/api/v1/schedule/production/list_by_area?page=${page}&size=${size}&sort=${sort}&order=${order}&status=active,inactive&keyword=${keyWord}&production_type=${productionType}&area_id=${areaId}&from_date_time=${fromDate || ""}&to_date_time=${toDate || ""}&is_completed=${isCompleted}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const createScheduleProduction = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/production/save`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const changeProductionScheduleStatus = async (
  id: string,
  status: string,
  interface_name: string
) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/production/change_status`,
      {
        id: id,
        status: status,
        interface_name: interface_name,
      },
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const getAreaList = async (sort: string, order: string, type: string, gradeType?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/location/list_all?sort=${sort}&order=${order}&status=active&type=${type}&grade_id=${gradeType || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getActiveInactiveAreaList = async (sort: string, order: string, type: string, gradeType?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/location/list_all?sort=${sort}&order=${order}&status=active,inactive&type=${type}&grade_id=${gradeType || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getProductList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/products/list`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getProductionOperators = async (data: any) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/operator/getProductionOperators?sort=id&order=asc&status=active&schedule_production_id=${data?.schedule_production_id}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//Schedule Operator
const getOperatorScheduleList = async (
  page: number,
  size: number,
  sort: string,
  order: string,
  keyWord: any,
  schedule_production_id: string,
  activityType?: string,
  processId?: string,
  status?: string,
  assignee?: string,
  fromDate?: string,
  toDate?: string,
  areaId?: string,
  location?: string,
  productNameId?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/operator/list?page=${page}&size=${size}&sort=${sort}&order=${order}&status=${status || "active"}&keyword=${keyWord}&schedule_production_id=${schedule_production_id}&activity_type_id=${activityType || ""}&process_id=${processId || ""}&user_master_id=${assignee || ""}&start_date_time=${fromDate || ""}&end_date_time=${toDate || ""}&area_id=${areaId || ""}&location_id=${location || ""}&product_id=${productNameId || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//get PersonnelMonitoringQR
const getPersonnelMonitoringQRDetails = async (
  page: number,
  size: number,
  sort: string,
  order: string,
  schedule_production_id: string,
  assignee?: string,
  fromDate?: string,
  toDate?: string,
  areaId?: string,
  productNameId?: string
) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/plates/list_plate_details?page=${page}&size=${size}&sort=${sort}&order=${order}&schedule_production_id=${schedule_production_id}&status=&keyword=&batch_number=&batch_id=&serial_number=&current_location_id=&area_id=${areaId}&incubator_id&lot_code&master_activities_id=3&start_date_time=${fromDate || ""}&end_date_time=${toDate || ""}&user_master_id=${assignee || ""}&product_id=${productNameId || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//Schedule Operator
const getCalenderScheduleList = async (
  areaId?: string,
  userId?: string,
  fromDate?: string,
  toDate?: string,
) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/operator/list?sort=id&order=desc&status=&keyword=&schedule_production_id=&activity_type_id=&process_id=&user_master_id=${userId}&area_id=${areaId}&start_date_time=${fromDate}&end_date_time=${toDate}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

//Schedule Operator
// const getCalenderScheduleList = async (
//   areaId?: string,
//   userId?: string,
//   fromDate?: string,
//   toDate?: string,
// ) => {
//   try {
//     const response = await axiosInstance.get(
//       `${baseUrl}/api/v1/schedule/operator/list?page=1&size=10&sort=id&order=desc&status=&keyword=&schedule_production_id=&activity_type_id=&process_id=&user_master_id=${userId}&area_id=${areaId}&start_date_time=${fromDate}&end_date_time=${toDate}`,
//       {
//         headers: {
//           "x-auth-token": authToken,
//           "x-userid": authUserID,
//         },
//       }
//     );
//     return response.data;
//   } catch (error) {
//     if (axios.isAxiosError(error)) {
//       return error.response?.data;
//     }
//   }
// };

const createScheduleOperator = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/operator/save`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const createScheduleOperatorBulk = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/operator/bulk_add`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const assignOperator = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/operator/assign`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const changeOperatorScheduleStatus = async (
  id: string,
  status: string,
  interface_name: string
) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/operator/change_status`,
      {
        id: id,
        status: status,
        interface_name: interface_name,
      },
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const getProductionSchedules = async (areaId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/list?sort=id&order=desc&status=active&area_id=${areaId || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const getProductionSchedule = async (areaId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/list?sort=id&order=desc&status=active&area_id=${areaId || ""}&is_completed=inprogress`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const getProductionSchedulesReport = async (areaId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/list?sort=id&order=desc&status=active,inactive&area_id=${areaId || ""}&is_completed=`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getCompletedProductionSchedulesReport = async (areaId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/list?sort=id&order=desc&status=active,inactive&area_id=${areaId || ""}&is_completed=1`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getQAProductionSchedules = async (
  page: number,
  size: number,
  sort:any,
  order:any,
  schedule_production_id?: string,
  approval_status?: string,
  fromDate?: string,
  toDate?: string,
  productNameId?: string,
  userId?: number) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/list?page=${page}&size=${size}&sort=${sort}&order=${order}&approval_status=${approval_status || ""}&schedule_production_id=${schedule_production_id}&start_date_time=${fromDate || ""}&end_date_time=${toDate || ""}&product_id=${productNameId || ""}&approved_by=${userId || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getProductionSchedulesAllStatus = async (areaId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/list?sort=id&order=desc&area_id=${areaId || ""}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const get_process_by_activity = async (master_activity_id: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/master_process/get_process_by_activity?master_activity_id=${master_activity_id}&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const getMasterUserList = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/empats/list_users?sort=id&order=desc&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getMasterUserListWithUserCode = async () => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/empats/list_users_with_id?sort=id&order=desc`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getBatchList = async (plateType?: string , mediaType?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/batches/list?sort=id&order=desc&plate_status=1&plate_size_type=${plateType}&plate_media_type=${mediaType || ""}&status=active`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getBatchListByAvailability = async (plateType?: string, activitWorkflowId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/batches/list_all_by_availability_v1?sort=id&order=desc&plate_status=1&plate_size_type=${plateType}&status=active&activity_workflow_id=${activitWorkflowId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getMediaBatchListByAvailability = async (plateType?: string, activitWorkflowId?: string, sizeId?: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/batches/get_media_tube_batches_by_availability?sort=id&order=desc&plate_status=1&plate_size_type=${plateType}&status=active&activity_workflow_id=${activitWorkflowId}&tube_size_id=${sizeId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getLotList = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/lots/list_lots?sort=id&order=asc&status=active&batch_id=${batchId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getLotListByAvailability = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/lots/list_all_lots_by_availability?sort=id&order=asc&status=active&batch_id=${batchId}&inspection_status=passed,pending,Not required`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getLotTubeListByAvailability = async (batchId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/lots/list_all_lots_tubes_by_availability?sort=id&order=asc&status=active&batch_id=${batchId}&inspection_status=passed,pending,Not required`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const generatePlateQr = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/plates/v2/generate_plate_qr_by_lot`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const generateBulkPlateQr = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/plates/v2/generate_bulk_plate_qr_by_lot`,
      // `${baseUrl}/api/v2/empats_plate_details_api/generate_bulk_plate_qr_by_lot`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const generateBulkPlateQrV2 = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      // `${baseUrl}/api/v2/empats_plate_details_api/generate_bulk_plate_qr_by_lot`,
      //`${baseUrl}/api/v2/empats_plate_details_api/generate_bulk_plate_qr_by_multiple_lot`,
      `${baseUrl}/api/v2/empats_plate_details_api/start_generate_plate_qr_async`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const generateSterilityTestSerielNo = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/sterility_test_serial_number/generate`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const checkQrGenerationStatus = async (processId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v2/empats_plate_details_api/get_plate_qr_async_status?id=${processId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const checkSterilityTestQrGenerationStatus = async (processId: string) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/sterility_test_serial_number/status?id=${processId}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getGeneratedProductionPlateQr = async (filter: any) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/get_qr_generated_plates?schedule_production_id=${filter?.schedule_production_id}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getGeneratedProductionPlateQrV2 = async (filter: any) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/get_qr_generated_plates?schedule_operator_id=${filter?.schedule_production_id}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getGeneratedProductionTubeBarcode = async (filter: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/barcodes/generate?ids=${filter?.schedule_production_id}&barcode_type=`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};


const check_area_activity_frequencies = async (filter: any) => {
  try {
    const response = await axiosInstance.get(
      `${baseUrl}/api/v1/schedule/production/check_area_activity_frequencies?&sort=${filter?.sort}&order=${filter?.order}&area_id=${filter?.area_id}&production_type=${filter?.production_type}`,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const get_locations = async (filter: any) => {
  try {
    let url = `${baseUrl}/api/v1/schedule/operator/get_locations?`;
    if (_h.objectHasValue(filter)) {
      Object.keys(filter).forEach((key: any) => {
        url += key + "=" + filter[key] + "&";
      });
    }
    const response = await axiosInstance.get(url, {
      headers: {
        "x-auth-token": authToken,
        "x-userid": authUserID,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const get_work_shifts = async () => {
  try {
    let url = `${baseUrl}/api/v1/schedule/work_shift/list?sort=id&status=active&order=asc`;
    const response = await axiosInstance.get(url, {
      headers: {
        "x-auth-token": authToken,
        "x-userid": authUserID,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const getOperatorSchedules = async (filter: any) => {
  try {
    let url = `${baseUrl}/api/v1/schedule/operator/list?`;
    if (_h.objectHasValue(filter)) {
      Object.keys(filter).forEach((key: any) => {
        url += key + "=" + filter[key] + "&";
      });
    }
    const response = await axiosInstance.get(url, {
      headers: {
        "x-auth-token": authToken,
        "x-userid": authUserID,
      },
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};

const reassignScheduleOperator = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/api/v1/schedule/operator/reassignScheduleOperator`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};
const changeCompleteStatus = async (dataToSend: any) => {
  try {
    const response = await axiosInstance.post(
      `${baseUrl}/production/change_completed_status`,
      dataToSend,
      {
        headers: {
          "x-auth-token": authToken,
          "x-userid": authUserID,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return error.response?.data;
    }
  }
};




const scheduleService = {
  // getAreaStatus,
  // getAreaByScan,
  // listAreaType,
  // getLocationPolicy,
  // getLocationStatus,
  // changePolicyStatus,
  // getSchedulePolicy,
  // changeScheduleStatus,
  // getParentAreaList,
  // getPolicyNameList,
  // createArea,
  // getExposurePointList,
  // getAreaId,
  // changeAreaStatus,
  // getAddAreaType,
  // geAreaDropDownList,
  // getHeirarchyType,
  // geLocationDropDownList,
  // getLocationPointList,
  // getIncubatorList,
  // geAreaDropDownPolicyList,
  changeCompleteStatus,
  getAreaList,
  getActiveInactiveAreaList,
  getProductList,
  getPlateGradeList,
  getAreaCategoryList,
  getFrequencyList,
  getActivityTypeList,
  createScheduleFrequency,
  changeFrequencyScheduleStatus,
  getProductionScheduleList,
  createScheduleProduction,
  changeProductionScheduleStatus,
  getOperatorScheduleList,
  getCalenderScheduleList,
  createScheduleOperator,
  changeOperatorScheduleStatus,
  getProductionSchedules,
  get_process_by_activity,
  getMasterUserList,
  getMasterUserListWithUserCode,
  getBatchList,
  getBatchListByAvailability,
  getLotListByAvailability,
  getLotList,
  generatePlateQr,
  getProductionOperators,
  getGeneratedProductionPlateQr,
  check_area_activity_frequencies,
  get_locations,
  get_work_shifts,
  createScheduleOperatorBulk,
  getOperatorSchedules,
  reassignScheduleOperator,
  generateBulkPlateQr,
  generateBulkPlateQrV2,
  checkQrGenerationStatus,
  assignOperator,
  getGeneratedProductionPlateQrV2,
  getPersonnelMonitoringQRDetails,
  getProductionSchedulesAllStatus,
  getQAProductionSchedules,
  getProductionSchedulesReport,
  getCompletedProductionSchedulesReport,
  getProductionSchedule,
  getMediaBatchListByAvailability,
  getLotTubeListByAvailability,
  generateSterilityTestSerielNo,
  checkSterilityTestQrGenerationStatus,
  getGeneratedProductionTubeBarcode
  // getCalenderScheduleList
};

export { scheduleService };
